import { useContext, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Title from 'components/common/title/';
import Loader from 'components/common/loader';
import Info from 'components/common/info';
import AppContext from 'AppContext';
import { trackView } from 'utils/analytics';
import ErrorBoundary from 'components/common/error';
import { initDashboard } from 'services';
import { DataGrid } from './components';
import I18n from 'i18n';
const { lookup } = new I18n();

const Output = () => {
  const appContext = useContext(AppContext);
  const [state, setState] = useState({
    selectedProject: null,
    loading: true
  });

  useEffect(() => {
    let isMounted = true; // Flag to track if the component is mounted

    const init = async context => {
      try {
        const selectedProject = await initDashboard(context);
        if (isMounted) {
          setState({
            selectedProject,
            loading: false
          });
        }
      } catch (e) {
        if (isMounted) {
          context.handleErrorMessage(e, context.logout, setState);
        }
      }
    };

    setState({ loading: true });
    init(appContext);

    // Cleanup function
    return () => {
      isMounted = false;
      // Add any cleanup logic for asynchronous operations here if needed.
    };
  }, [appContext]);

  useEffect(() => {
    trackView('output');
  }, []);

  return (
    <Container>
      <Loader loading={state.loading} />
      <Title id="alert-output">
        {lookup('section_alert_output')}
        <Info copy={lookup('tooltip_alert_output')} />
      </Title>
      {state?.selectedProject && (
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ErrorBoundary>
              <DataGrid {...state} />
            </ErrorBoundary>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default Output;
